export const EXPENSE_EXPORT_ID = "Lista de gastos";
export const EXPENSE_TITLE = "Lista de gastos";

export const EXPENSE_PROPERTIES = {
    trip: "Viaje",
    subRoute: "Ruta",        
    serial: "No. Documento",
    username: "usuario",    
    responsibleName: "Responsable",
    reasonForExpense: "Motivo de Gasto",
    typeDocument: "Tipo de Documento",
    classDocument: "Clase de Documento",
    amount: "Monto",
    creationDateTime: 'Fecha de Creacion',
    updatedDateTime: 'Fecha de Actualizacion',
    comment: 'observación'
};

export const DATE_FIELDS = [
    "creationDateTime",
    "updatedDateTime"
];

export const CURRENCYFIELDS = [
  "amount"
];

export const FORMATTER = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const DATE_TIME_FORMATTER = new Intl.DateTimeFormat("es-HN", {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
//   second: '2-digit',
//   hour12: false // Formato 24 horas
});